"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_color_1 = require("react-color");
var PICKER_WIDTH = 225;
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.sel = '';
        _this.state = {
            open: false,
            color: ''
        };
        _this.getColor = function () {
            var _a = _this.props, editor = _a.editor, name = _a.name, getValue = _a.getValue, defaultColor = _a.defaultColor;
            var attrs = editor.getFormat()[name];
            return Boolean(attrs) && attrs && attrs.color
                ? getValue(attrs)
                : defaultColor;
        };
        _this.updateColor = function () {
            var selection = _this.props.editor.getSelection();
            if (selection && _this.sel !== JSON.stringify(selection)) {
                _this.sel = JSON.stringify(selection);
                var color = _this.getColor();
                if (color === _this.props.defaultColor)
                    return;
                _this.setState({ color: color });
                _this.setIconColor(color);
            }
        };
        _this.listenClose = function () { return document.addEventListener('mousedown', _this.judge); };
        _this.unListenClose = function () {
            return document.removeEventListener('mousedown', _this.judge);
        };
        _this.judge = function (e) {
            var target = e.target;
            if (_this.$btn && _this.$btn.contains(target))
                return;
            if (!_this.picker)
                return _this.hide();
            if (!_this.picker.contains(target)) {
                _this.hide();
            }
            else if (_this.picker.contains(target) && !target.closest('input')) {
                requestAnimationFrame(function () { return _this.props.editor.focus(); });
            }
        };
        _this.changeColor = function (_color) {
            var _a;
            var isInput = document.activeElement
                ? document.activeElement.tagName === 'INPUT'
                : false;
            var _b = _this.props, editor = _b.editor, getAttrs = _b.getAttrs, name = _b.name;
            var attrs = getAttrs(_color.rgb);
            editor.setFormat((_a = {}, _a[name] = attrs, _a), { focus: !isInput });
            _this.setState({ color: attrs.color }, function () { return _this.setIconColor(attrs.color); });
        };
        _this.setIconColor = function (color) {
            var mountDOM = _this.props.mountDOM;
            if (mountDOM && mountDOM.querySelector('svg')) {
                var paths = mountDOM.querySelectorAll('path');
                [].slice.call(paths).forEach(function (path) {
                    if (path.getAttribute('color-line')) {
                        path.setAttribute('style', "fill: " + color);
                    }
                });
            }
        };
        _this.hide = function () { return _this.setState({ open: false }, _this.unListenClose); };
        _this.open = function () {
            _this.fixPos();
            _this.updateColor();
            _this.setState({ open: true }, _this.listenClose);
        };
        _this.toggleVisible = function () { return (_this.state.open ? _this.hide() : _this.open()); };
        var color = _this.getColor();
        _this.state = {
            color: color,
            open: false
        };
        _this.updateColor();
        _this.$btn = _this.props.mountDOM.querySelector('.syl-toolbar-button');
        return _this;
    }
    ColorPicker.prototype.fixPos = function () {
        var mountDOM = this.props.mountDOM;
        if (!mountDOM || !this.picker || !this.picker.parentElement)
            return;
        var rect = this.props.mountDOM.getBoundingClientRect();
        var avWidth = window.innerWidth;
        if (avWidth - rect.left < PICKER_WIDTH) {
            this.picker.parentElement.setAttribute('style', "margin-left: -" + (PICKER_WIDTH - (rect.right - rect.left)) + "px");
        }
        else {
            this.picker.parentElement.setAttribute('style', '');
        }
    };
    ColorPicker.prototype.componentDidMount = function () {
        this.$btn && this.$btn.addEventListener('click', this.toggleVisible);
    };
    ColorPicker.prototype.componentWillUnmount = function () {
        this.$btn && this.$btn.removeEventListener('click', this.toggleVisible);
    };
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.state, open = _a.open, color = _a.color;
        if (!open)
            return null;
        return (react_1.default.createElement("div", { className: "color-picker-container", style: {
                userSelect: 'none',
                width: PICKER_WIDTH + "px",
                position: 'absolute',
                zIndex: 99
            }, "data-syl-toolbar": "true", ref: function (el) { return el && (_this.picker = el); } },
            react_1.default.createElement(react_color_1.ChromePicker, { color: color, onChange: this.changeColor })));
    };
    return ColorPicker;
}(react_1.default.Component));
exports.ColorPicker = ColorPicker;
//# sourceMappingURL=index.js.map